var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "container mx-auto" };
const _hoisted_2 = { class: "p-20 mt-12 h-754px mx-auto border-2 border-orange border-solid bg-archiv bg-no-repeat bg-right-top" };
const _hoisted_3 = { class: "text-lg mb-2 font-weight-bold" };
const _hoisted_4 = { class: "flex justify-between" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("a", {
    href: "/project",
    class: "px-6 py-3 text-white no-underline bg-orange rounded"
}, " Alle Projekte ", -1);
const _hoisted_6 = ["href"];
const _hoisted_7 = ["value"];
const _hoisted_8 = ["value"];
const _hoisted_9 = ["value"];
const _hoisted_10 = ["value"];
const _hoisted_11 = ["value"];
const _hoisted_12 = ["onSubmit"];
const _hoisted_13 = /*#__PURE__*/ _createStaticVNode("<footer class=\"container mx-auto mt-1\"><div class=\"p-0 w-11/12 mx-auto text-white text-center\"><a href=\"https://www.ufs-tools.com/datenschutzerklaerung.html\" class=\"text-white\" target=\"_blank\">Datenschutzerklärung</a>    |   <a href=\"https://www.ufs-tools.com/impressum.html\" class=\"text-white\" target=\"_blank\">Impressum</a>    |   <a href=\"https://www.ufs-tools.com/downloads/Handbuch.pdf\" class=\"text-white\" target=\"_blank\" title=\"Handbuch als PDF laden\">Handbuch</a></div></footer>", 1);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("h3", { class: "text-xl font-semibold text-gray-900" }, " Rezepte direkt von Calcmenu Web beziehen ... ", -1);
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("svg", {
    "aria-hidden": "true",
    class: "w-5 h-5",
    fill: "currentColor",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
}, [
    /*#__PURE__*/ _createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
        "clip-rule": "evenodd"
    })
], -1);
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("span", { class: "sr-only" }, "Schliessen", -1);
const _hoisted_17 = [
    _hoisted_15,
    _hoisted_16
];
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("button", {
    type: "submit",
    class: "mb-2 w-1/2 px-6 py-2.5 bg-orange text-white text-xs leading-normal uppercase"
}, "Rezepte laden ", -1);
import axios from "axios";
import { ref, computed, onMounted } from 'vue';
import ProjectsComponent from './components/ProjectsComponent.vue';
import ModalComponent from './components/CalmenuComponent.vue';
import VueSimpleAlert from "vue3-simple-alert";
/* Image File Upload */
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
// Create component
export const componentName = 'Project';
const __default__ = {
    name: componentName,
    inheritAttrs: false,
};
export default /*#__PURE__*/ _defineComponent(Object.assign(Object.assign({}, __default__), { setup(__props, { expose }) {
        var _a;
        const location = window.location.href;
        const sections = location.split('/');
        const project = (_a = sections.pop()) !== null && _a !== void 0 ? _a : '';
        const baseUrl = '/api/project/';
        const uploadUrl = '/api/tmp-upload/';
        const deleteUrl = '/api/tmp-delete/';
        const endpoint = ref(project);
        const showModal = ref(false);
        const filespath = computed(() => baseUrl + endpoint.value);
        const tmpUpload = computed(() => uploadUrl + endpoint.value);
        const tmpDelete = computed(() => deleteUrl + endpoint.value);
        const FilePond = vueFilePond(FilePondPluginFileValidateType);
        const confirmOptions = {
            confirmButtonColor: '#b3b3b3',
            cancelButtonColor: '#ff7849',
            confirmButtonText: 'JA',
            cancelButtonText: 'NEIN',
        };
        const alertOptions = {
            confirmButtonColor: '#b3b3b3'
        };
        const pond = ref(null);
        expose({ pond });
        let filesList = ref([]);
        let filesToUpload = ref([]);
        let csrf = ref('');
        let projectname = ref('');
        let recipexml = ref('');
        let recipepdf = ref('');
        let template = ref('');
        let recipeForm = ref(null);
        const removeElement = (filename) => {
            VueSimpleAlert.confirm("Soll die Datei \"" + filename + "\" gelöscht werden ?", "", "warning", confirmOptions).then(() => {
                deleteFile(filename);
            });
        };
        const deleteFile = (filename) => __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield axios.post('/api/remove-file', { project: endpoint.value, file: filename });
                if (response.status === 200) {
                    yield fetchData();
                }
            }
            catch (error) {
                VueSimpleAlert.alert("Beim Löschen ist ein Fehler aufgetreten?", "", "error", alertOptions).then(() => {
                    console.error(error);
                });
            }
        });
        const readExcel = (filename) => __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield axios.post('/api/excel', { project: endpoint.value, filename: filename });
                if (response.status === 200) {
                    yield fetchData();
                }
            }
            catch (error) {
                VueSimpleAlert.alert("Beim Laden der Rezepte ist ein Fehler aufgetreten?", "", "error", alertOptions).then(() => { });
            }
        });
        const submitForm = (filename) => {
            var _a, _b;
            recipepdf.value = '';
            recipexml.value = filename;
            const el = (_a = recipeForm.value) === null || _a === void 0 ? void 0 : _a.elements.namedItem('filename');
            el.value = recipexml.value;
            recipexml.value = '';
            (_b = recipeForm.value) === null || _b === void 0 ? void 0 : _b.submit();
        };
        const doDownload = (filename) => {
            var _a, _b;
            recipexml.value = '';
            recipepdf.value = filename;
            const el = (_a = recipeForm.value) === null || _a === void 0 ? void 0 : _a.elements.namedItem('pdffile');
            el.value = recipepdf.value;
            recipepdf.value = '';
            (_b = recipeForm.value) === null || _b === void 0 ? void 0 : _b.submit();
        };
        const doEdit = (filename) => {
            try {
                axios.post('/editxml', { project: endpoint.value, filename: filename });
            }
            catch (error) {
                VueSimpleAlert.alert("Beim Laden der XML-Datei ist ein Fehler aufgetreten?", "", "error", alertOptions).then(() => { });
            }
        };
        const afterUpload = (error, file) => __awaiter(this, void 0, void 0, function* () {
            if (error)
                return;
            if (pond && pond.value !== null) {
                pond.value.removeFile(file.id);
            }
            yield fetchData();
        });
        const fetchData = () => __awaiter(this, void 0, void 0, function* () {
            const res = yield fetch(filespath.value);
            filesList.value = yield res.json();
        });
        const handleFilePondAddFile = (error) => {
            setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                if (error) {
                    yield VueSimpleAlert.alert('Beim Upload ist ein Fehler aufgetreten.', "", "error");
                }
            }), 500);
        };
        const toggleModal = () => {
            showModal.value = !showModal.value;
        };
        const extraPage = () => {
            var _a, _b, _c;
            recipepdf.value = '';
            const template = (_a = recipeForm.value) === null || _a === void 0 ? void 0 : _a.elements.namedItem('template');
            template.value = '11';
            const el = (_b = recipeForm.value) === null || _b === void 0 ? void 0 : _b.elements.namedItem('filename');
            el.value = '';
            endpoint.value;
            (_c = recipeForm.value) === null || _c === void 0 ? void 0 : _c.submit();
        };
        const submitRecipes = (recipes, language) => __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield axios.post('/api/project-recipes', { project: endpoint.value, recipes: recipes, language });
                toggleModal();
                if (response.status === 200) {
                    yield fetchData();
                }
            }
            catch (error) {
                toggleModal();
                VueSimpleAlert.alert("Beim Laden der Rezepte ist ein Fehler aufgetreten?", "", "error", alertOptions).then(() => { });
            }
        });
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            yield fetchData();
            recipexml.value = project;
            projectname.value = project;
            let meta = document.querySelector('meta[name="csrf-token"]');
            if (meta && meta.getAttributeNode('content')) {
                csrf.value = meta.getAttribute('content') || 'no-csrf-token-provided';
            }
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h2", _hoisted_3, _toDisplayString(endpoint.value), 1),
                    _createVNode(ProjectsComponent, {
                        onOnRemoveElement: removeElement,
                        onOnReadExcel: readExcel,
                        onOnSubmitForm: submitForm,
                        onOnDownload: doDownload,
                        onOnEdit: doEdit,
                        projectname: _unref(projectname),
                        filesList: _unref(filesList)
                    }, null, 8, ["projectname", "filesList"]),
                    _createVNode(_unref(FilePond), {
                        style: { "overflow": "hidden", "height": "127px" },
                        name: "uploader",
                        ref_key: "pond",
                        ref: pond,
                        "label-idle": "Dateien zum Upload hierherziehen ...",
                        "label-file-processing": "Fortschritt",
                        "label-file-processing-complete": "Upload abgeschlossen",
                        "label-tap-to-cancel": "abbrechen",
                        "accepted-file-types": "image/jpeg,image/png,application/vnd.ms-excel,application/pdf,application/xml,text/xml",
                        "allow-revert": "false",
                        "allow-multiple": true,
                        credits: 'false',
                        files: _unref(filesToUpload),
                        removeFile: afterUpload,
                        onProcessfile: afterUpload,
                        onAddfile: handleFilePondAddFile,
                        server: {
                            process: {
                                url: _unref(tmpUpload),
                                method: 'POST',
                                headers: {
                                    'X-CSRF-TOKEN': _unref(csrf)
                                },
                            },
                        }
                    }, null, 8, ["files", "server"]),
                    _createElementVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _createElementVNode("button", {
                            class: "px-6 py-3 text-white no-underline bg-orange rounded",
                            onClick: toggleModal
                        }, " Rezepte direkt laden"),
                        _createElementVNode("button", {
                            class: "px-6 py-3 text-white no-underline bg-orange rounded",
                            onClick: extraPage
                        }, " Sonderseiten "),
                        _createElementVNode("a", {
                            href: '/booklet/' + endpoint.value,
                            class: "px-6 py-3 text-white no-underline bg-orange rounded"
                        }, " Seiten sortieren ", 8, _hoisted_6)
                    ])
                ]),
                _createElementVNode("form", {
                    ref_key: "recipeForm",
                    ref: recipeForm,
                    class: "hidden",
                    method: "post",
                    action: "/recipe"
                }, [
                    _createElementVNode("input", {
                        type: "hidden",
                        name: "project",
                        value: _unref(projectname)
                    }, null, 8, _hoisted_7),
                    _createElementVNode("input", {
                        type: "hidden",
                        name: "filename",
                        value: _unref(recipexml)
                    }, null, 8, _hoisted_8),
                    _createElementVNode("input", {
                        type: "hidden",
                        name: "pdffile",
                        value: _unref(recipepdf)
                    }, null, 8, _hoisted_9),
                    _createElementVNode("input", {
                        type: "hidden",
                        name: "template",
                        value: _unref(template)
                    }, null, 8, _hoisted_10),
                    _createElementVNode("input", {
                        type: "hidden",
                        name: "_token",
                        value: _unref(csrf)
                    }, null, 8, _hoisted_11),
                    _createElementVNode("input", {
                        type: "submit",
                        onSubmit: _withModifiers(submitForm, ["prevent"])
                    }, null, 40, _hoisted_12)
                ], 512),
                _hoisted_13,
                (showModal.value)
                    ? (_openBlock(), _createBlock(ModalComponent, {
                        key: 0,
                        onClose: toggleModal,
                        onSubmitCalmenuForm: submitRecipes
                    }, {
                        header: _withCtx(() => [
                            _createElementVNode("div", { class: "flex items-start justify-between p-4 border-b roundedt dark:border-gray-600" }, [
                                _hoisted_14,
                                _createElementVNode("button", {
                                    type: "button",
                                    onClick: toggleModal,
                                    class: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                                }, _hoisted_17)
                            ])
                        ]),
                        footer: _withCtx(() => [
                            _createElementVNode("div", { class: "flex items-center p-6 space-x-2 border-t border-gray-200 rounded-b dark:border-gray-600" }, [
                                _hoisted_18,
                                _createElementVNode("button", {
                                    type: "button",
                                    onClick: toggleModal,
                                    class: "mb-2 w-1/2 px-6 py-2.5 bg-orange text-white text-xs leading-normal uppercase"
                                }, "Abbrechen ")
                            ])
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    } }));
